import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component VolumeHighIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <VolumeHighIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <VolumeHighIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const VolumeHighIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="VolumeHighIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M14 3.23c4 .91 7 4.49 7 8.77 0 4.187-2.871 7.704-6.74 8.707l-.26.063V18.7c2.89-.86 5-3.53 5-6.7a7.005 7.005 0 0 0-4.754-6.632L14 5.29zM12 4v16l-5-5H3V9h4zm2 3.97c1.5.74 2.5 2.26 2.5 4.03a4.4 4.4 0 0 1-2.307 3.903L14 16z"
      />
    </svg>
  )
);
VolumeHighIcon.displayName = "VolumeHighIcon";
export default VolumeHighIcon;
